/******************************************************************************
 *** MbrasRejoinApply ** 재가입 신청서
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

import MemberFile from "../FileBox/MemberFile";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";

const MbrasRejoinApply = (props: any) => {
    const {
        mbrasId,
        mbrasAtrzDocId,
        selectedMember,
        setModalOpen,
        setModalStep,
        setCallTime,
    } = props;

    const [mbrasNm           , setMbrasNm           ] = React.useState(""); // 성명
    const [upOgnzCd          , setUpOgnzCd          ] = React.useState(""); // 현재 본부
    const [ogdpOrgCd         , setOgdpOrgCd         ] = React.useState(""); // 현재 지부
    const [wtjrNm            , setWtjrNm            ] = React.useState(""); // 현재 관내
    const [frstJncmpYmd      , setFrstJncmpYmd      ] = React.useState(""); // 입직년월일
    const [mbrasJoinSttsCd   , setMbrasJoinSttsCd   ] = React.useState(""); // 현재 조합원 상태

    const [showJoinHistoryTable, setShowJoinHistoryTable] = React.useState(true);  // 가입/탈퇴 이력 표시
    const [isWithdraw          , setIsWithdraw          ] = React.useState(true);  // 탈퇴 이력 여부
    const [joinYmd             , setJoinYmd             ] = React.useState("");    // 가입 신청일
    const [aprvYmd             , setAprvYmd             ] = React.useState("");    // 가입 승인일
    const [rglrRegMm           , setRglrRegMm           ] = React.useState("");    // 조합원 등록월
    const [whdwlDt             , setWhdwlDt             ] = React.useState("");    // 탈퇴 신청일
    const [whdwlAprvDt         , setWhdwlAprvDt         ] = React.useState("");    // 탈퇴 승인일
    const [whdwlMm             , setWhdwlMm             ] = React.useState("");    // 조합원 탈퇴월

    const [chgMbrasNm        , setChgMbrasNm        ] = React.useState("");   // 재가입 성명
    const [chgTelno          , setChgTelno          ] = React.useState("");   // 재가입 전화번호
    const [chgBrdtDate       , setChgBrdtDate       ] = React.useState("");   // 재가입 생년월일
    const [chgGndrCd         , setChgGndrCd         ] = React.useState("");   // 재가입 성별
    const [chgLbrShpSeCd     , setChgLbrShpSeCd     ] = React.useState("");   // 재가입 근로형태
    const [chgOcptTypeCd     , setChgOcptTypeCd     ] = React.useState("");   // 재가입 직종
    const [chgUpOgnzCd       , setChgUpOgnzCd       ] = React.useState("");   // 재가입 본부
    const [chgOgdpOrgCd      , setChgOgdpOrgCd      ] = React.useState("");   // 재가입 지부
    const [chgWtjrNm         , setChgWtjrNm         ] = React.useState("");   // 재가입 관내
    const [chgAddr           , setChgAddr           ] = React.useState("");   // 재가입 주소
    const [chgMbrasJoinSttsCd, setChgMbrasJoinSttsCd] = React.useState("01"); // 조합원 상태
    const [wthdStatusCd      , setWthdStatusCd      ] = React.useState("");   // 현재 원천징수 상태
    const [chgWthdStatusCd   , _setChgWthdStatusCd  ] = React.useState("W01");// 재가입 원천징수 상태

    const [applyDt           , setApplyDt           ] = React.useState("");   // 재가입 신청일자
    const [memo              , setMemo              ] = React.useState("");   // 메모
    const [atrzSttsCd        , setAtrzSttsCd        ] = React.useState("01"); // 결재상태
    const [atrzOpnnCn        , setAtrzOpnnCn        ] = React.useState("");   // 반려사유
    const [listLine          , setListLine          ] = React.useState<any[]>([]); // 결재 라인 정보
    const [openLine          , setOpenLine          ] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [joinFile          , setJoinFile          ] = React.useState<File>(); // 가입신청서
    const [joinFileNm        , setJoinFileNm        ] = React.useState("");     // 가입신청서명
    const [joinAtchFileId    , setJoinAtchFileId    ] = React.useState("");     // 가입신청서 첨부파일 ID

    const [wthdFile          , setWthdFile          ] = React.useState<File>(); // 원천징수 동의서
    const [wthdFileNm        , setWthdFileNm        ] = React.useState("");     // 원천징수 동의서명
    const [wthdAtchFileId    , setWthdAtchFileId    ] = React.useState("");     // 원천징수 첨부파일 ID

    const [etcFile           , setEtcFile           ] = React.useState<File>(); // 기타 첨부파일
    const [etcFileNm         , setEtcFileNm         ] = React.useState("");     // 기타 첨부파일명
    const [etcAtchFileId     , setEtcAtchFileId     ] = React.useState("");     // 기타 첨부파일 ID

    // 현재 조합원 정보
    React.useEffect(() => {
        if (!selectedMember) return;

        setMbrasNm         (String(selectedMember.mbrasNm));          // 성명
        setUpOgnzCd        (String(selectedMember.upOgnzCd));         // 현재 본부
        setOgdpOrgCd       (String(selectedMember.ogdpOrgCd));        // 현재 지부
        setWtjrNm          (String(selectedMember.wtjrNm));           // 현재 관내
        setFrstJncmpYmd    (String(selectedMember.frstJncmpYmd));     // 입직년월일
        setMbrasJoinSttsCd (String(selectedMember.mbrasJoinSttsCd));  // 현재 조합원 상태
        setWthdStatusCd    (String(selectedMember.wthdStatusCd));     // 현재 원천징수 상태

        setShowJoinHistoryTable (selectedMember.showJoinHistoryTable !== false); // 가입/탈퇴 이력 표시
        setIsWithdraw           (selectedMember.isWithdraw !== false);             // 탈퇴 이력 여부
        setJoinYmd              (String(selectedMember.joinYmd));                  // 가입 신청일
        setAprvYmd              (String(selectedMember.aprvYmd));                  // 가입 승인일
        setRglrRegMm            (String(selectedMember.rglrRegMm));                // 조합원 등록월
        setWhdwlDt              (String(selectedMember.whdwlDt));                  // 탈퇴 신청일
        setWhdwlAprvDt          (String(selectedMember.whdwlAprvDt));              // 탈퇴 승인일
        setWhdwlMm              (String(selectedMember.whdwlMm));                  // 조합원 탈퇴월

        if (Util.isEmpty(mbrasAtrzDocId)) {
            setChgMbrasNm   (String(selectedMember.mbrasNm));    // 재가입 성명 기본값
            setChgUpOgnzCd  (String(selectedMember.upOgnzCd));   // 재가입 본부 기본값
            setChgOgdpOrgCd (String(selectedMember.ogdpOrgCd));  // 재가입 지부 기본값
            setChgWtjrNm    (String(selectedMember.wtjrNm));     // 재가입 관내 기본값
        }
    }, [selectedMember, mbrasAtrzDocId]);

    // 기존 재가입 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId, // 조합원 결재 문서 ID
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc; // 변경 결재 문서정보
                const listItem = res.result.listItem; // 변경 신청 내역
                const listFile = res.result.listFile; // 첨부파일 목록
                const atrzLine = res.result.listLine; // 결재라인

                const upOgnzItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "03"); // 본부 변경정보
                const ogdpOrgItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "04"); // 지부 변경정보
                const wtjrItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "05"); // 관내 변경정보
                const joinSttsItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "07"); // 조합원 상태 변경정보

                setChgMbrasNm    (String(mbrasDoc.mbrasNm));     // 재가입 성명
                setChgTelno      (String(mbrasDoc.telno));       // 재가입 전화번호
                setChgBrdtDate   (String(mbrasDoc.brdtDate));    // 재가입 생년월일
                setChgGndrCd     (String(mbrasDoc.gndrCd));      // 재가입 성별
                setChgLbrShpSeCd (String(mbrasDoc.lbrShpSeCd));  // 재가입 근로형태
                setChgOcptTypeCd (String(mbrasDoc.ocptTypeCd));  // 재가입 직종
                setChgAddr       (String(mbrasDoc.addr));        // 재가입 주소

                if (upOgnzItem)   setChgUpOgnzCd        (String(upOgnzItem.chgAfterCn));   // 재가입 본부
                if (ogdpOrgItem)  setChgOgdpOrgCd       (String(ogdpOrgItem.chgAfterCn));  // 재가입 지부
                if (wtjrItem)     setChgWtjrNm          (String(wtjrItem.chgAfterCn));     // 재가입 관내
                if (joinSttsItem) setChgMbrasJoinSttsCd (String(joinSttsItem.chgAfterCn)); // 재가입 상태

                setFrstJncmpYmd (String(mbrasDoc.frstJncmpYmd)); // 입직년월일
                setApplyDt      (String(mbrasDoc.applyDt));      // 재가입 신청일자
                setMemo         (String(mbrasDoc.memo));         // 메모
                setAtrzSttsCd   (String(mbrasDoc.atrzSttsCd));   // 결재상태
                setAtrzOpnnCn   (String(mbrasDoc.atrzOpnnCn));   // 반려사유
                setListLine     (atrzLine);                       // 결재라인

                const joinFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "01"); // 가입신청서
                const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02"); // 원천징수 첨부파일
                const etcFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                if (joinFileInfo) {
                    setJoinAtchFileId(String(joinFileInfo.mbrasAtchFileId)); // 가입신청서 첨부파일 ID
                    setJoinFileNm    (String(joinFileInfo.fileNm));          // 가입신청서 첨부파일명
                }

                if (wthdFileInfo) {
                    setWthdAtchFileId(String(wthdFileInfo.mbrasAtchFileId)); // 원천징수 첨부파일 ID
                    setWthdFileNm    (String(wthdFileInfo.fileNm));          // 원천징수 첨부파일명
                }

                if (etcFileInfo) {
                    setEtcAtchFileId(String(etcFileInfo.mbrasAtchFileId));   // 기타 첨부파일 ID
                    setEtcFileNm    (String(etcFileInfo.fileNm));            // 기타 첨부파일명
                }

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId]);

    const getParamData = (saveAtrzSttsCd: string) => {
        return {
            mbrasAtrzDocId    : mbrasAtrzDocId,     // 조합원 결재 문서 ID
            mbrasAtrzSeCd     : "11",                // 재가입
            mbrasId           : mbrasId,             // 조합원 ID

            mbrasNm           : chgMbrasNm,          // 재가입 성명
            telno             : chgTelno,            // 재가입 전화번호
            brdtDate          : chgBrdtDate,         // 재가입 생년월일
            gndrCd            : chgGndrCd,           // 재가입 성별
            lbrShpSeCd        : chgLbrShpSeCd,       // 재가입 근로형태
            ocptTypeCd        : chgOcptTypeCd,       // 재가입 직종
            ogdpOrgCd         : chgOgdpOrgCd,        // 재가입 지부
            wtjrNm            : chgWtjrNm,           // 재가입 관내
            addr              : chgAddr,             // 재가입 주소
            frstJncmpYmd      : frstJncmpYmd,        // 입직년월일
            memo              : memo,                // 메모
            mbrasJoinSttsCd   : chgMbrasJoinSttsCd,  // 재가입 조합원 상태
            wthdStatusCd      : chgWthdStatusCd,     // 재가입 원천징수 상태

            nowUpOgnzCd       : upOgnzCd,            // 현재 본부
            nowOgdpOrgCd      : ogdpOrgCd,           // 현재 지부
            nowWtjrNm         : wtjrNm,              // 현재 관내
            nowMbrasJoinSttsCd: mbrasJoinSttsCd,     // 현재 조합원 상태
            nowWthdStatusCd   : wthdStatusCd,        // 현재 원천징수 상태

            chgUpOgnzCd       : chgUpOgnzCd,         // 재가입 본부
            chgOgdpOrgCd      : chgOgdpOrgCd,        // 재가입 지부
            chgWtjrNm         : chgWtjrNm,           // 재가입 관내
            chgMbrasJoinSttsCd: chgMbrasJoinSttsCd,  // 변경 조합원 상태
            chgWthdStatusCd   : chgWthdStatusCd,     // 변경 원천징수 상태

            applyDt           : applyDt,             // 재가입 신청일자
            atrzSttsCd        : saveAtrzSttsCd,      // 01: 임시저장, 02: 작성완료

            joinFile          : joinFile,            // 가입신청서
            wthdFile          : wthdFile,            // 원천징수 동의서
            etcFile           : etcFile,             // 기타 첨부파일
            callType          : "MEMBER",            // 첨부파일 저장경로
        };
    };

    const handleSave = (saveAtrzSttsCd: string) => {
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgMbrasNm)) { AppContext.openAlert({ title: "성명 확인", msg: "성명을 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgTelno)) { AppContext.openAlert({ title: "전화번호 확인", msg: "전화번호를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgBrdtDate)) { AppContext.openAlert({ title: "생년월일 확인", msg: "생년월일을 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgGndrCd)) { AppContext.openAlert({ title: "성별 확인", msg: "성별을 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgLbrShpSeCd)) { AppContext.openAlert({ title: "근로형태 확인", msg: "근로형태를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgOcptTypeCd)) { AppContext.openAlert({ title: "직종 확인", msg: "직종을 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgUpOgnzCd)) { AppContext.openAlert({ title: "본부 확인", msg: "본부를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isNotEmpty(chgUpOgnzCd) && Util.isEmpty(chgOgdpOrgCd)) { AppContext.openAlert({ title: "지부 확인", msg: "본부를 선택한 경우 지부도 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && chgLbrShpSeCd === "01" && Util.isEmpty(frstJncmpYmd)) { AppContext.openAlert({ title: "입직년월일 확인", msg: "입직년월일을 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(applyDt)) { AppContext.openAlert({ title: "재가입 신청일자 확인", msg: "재가입 신청일자를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgAddr)) { AppContext.openAlert({ title: "주소 확인", msg: "주소를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && !joinFile && Util.isEmpty(joinAtchFileId)) { AppContext.openAlert({ title: "첨부파일 확인", msg: "가입신청서를 첨부해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && !wthdFile && Util.isEmpty(wthdAtchFileId)) { AppContext.openAlert({ title: "첨부파일 확인", msg: "원천징수 동의서를 첨부해주세요.", icon: "warning" }); return; }

        const saveTitle = saveAtrzSttsCd === "01" ? "임시저장" : "작성완료";
        const saveMsg = saveAtrzSttsCd === "01" ? "임시 저장하시겠습니까?" : "작성완료 처리하시겠습니까?";

        AppContext.openAlert({
            title      : saveTitle,
            msg        : saveMsg,
            confirmText: saveTitle,
            handleConfirm: () => {
                const paramData = getParamData(saveAtrzSttsCd);

                AppContext.showSpinner();

                Axios.dataAccess({
                    url        : "system/mbras/chg/save-mbras-atrz-chg.do",
                    methodType : "post",
                    isMultipart: true,
                    paramData  : paramData,
                    onSuccessFn: () => {
                        setAtrzSttsCd(saveAtrzSttsCd);

                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "저장 완료",
                            msg  : saveAtrzSttsCd === "01" ? "임시저장 처리되었습니다." : "작성완료 처리되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    const handleDelete = () => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.openAlert({
            title      : "삭제",
            msg        : "정말 삭제하시겠습니까?",
            confirmText: "삭제하기",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url       : "system/mbras/chg/delete-mbras-atrz-chg.do",
                    methodType: "post",
                    paramType : "json",
                    paramData : {
                        mbrasAtrzDocId: mbrasAtrzDocId,
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "삭제 완료",
                            msg  : "삭제가 완료되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    return (
        <div className="w100p dpFlx">
            <div className="w630">
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                            showOrgInfo={true}
                        />
                    </div>
                )}

                {/* 조합원 정보 */}
                <div className="m10">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">조합원 정보</div>

                    <div className="p14 bd1 bdcDDDDDD bdrd10 bgcFAFAFA bsBdb">
                        <div className="dpFlx flxNowrap jcSb">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">성명</span>
                                <TextBox
                                    value={mbrasNm}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">본부</span>
                                <SelectBox
                                    value={upOgnzCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getUpOrgCodeArray("01")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">지부</span>
                                <SelectBox
                                    value={ogdpOrgCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">관내</span>
                                <TextBox
                                    value={wtjrNm}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 가입/탈퇴 이력 */}
                {showJoinHistoryTable && (
                    <div className="ml10 mr10 mb10 mt5 p14 bd1 bdcDDDDDD bdrd10 bgcFAFAFA bsBdb">
                        <div className="fm-b fs14 fc111111 mb12">조합원 가입/탈퇴 이력</div>

                        <div className="bgcWhite w100p">
                            <table
                                className="bd1 bdcDDDDDD bdrd2"
                                style={{ borderCollapse: "collapse", width: "100%" }}
                            >
                                <colgroup>
                                    <col style={{ width: "15%" }} />
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "30%" }} />
                                    <col style={{ width: "25%" }} />
                                </colgroup>

                                <thead>
                                    <tr className="bgcFFF5ED h30" style={{ borderBottom: "1px solid #ccc" }}>
                                        <th className="fm-b fs13 fc555555 taC">구분</th>
                                        <th className="fm-b fs13 fc555555 taC">신청일</th>
                                        <th className="fm-b fs13 fc555555 taC">승인일</th>
                                        <th className="fm-b fs13 fc555555 taC">조합원 등록/탈퇴월</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="h30" style={{ borderBottom: isWithdraw ? "1px solid #ccc" : "none" }}>
                                        <td className="taC">
                                            <span className="fm-c fs13 fc333333">가입</span>
                                        </td>
                                        <td className="taC">
                                            <span className="fm-c fs13 fc333333">
                                                {Util.cvtDateStrForm(joinYmd, "-", "YYYYMMDD")}
                                            </span>
                                        </td>
                                        <td className="taC">
                                            <span className="fm-c fs13 fc333333">
                                                {Util.cvtDateStrForm(aprvYmd, "-", "YYYYMMDD")}
                                            </span>
                                        </td>
                                        <td className="taC">
                                            <span className="fm-c fs13 fc333333">
                                                {Util.cvtMonthStrForm(rglrRegMm)}
                                            </span>
                                        </td>
                                    </tr>

                                    {isWithdraw && (
                                        <tr className="h30">
                                            <td className="taC">
                                                <span className="fm-c fs13 fc333333">탈퇴</span>
                                            </td>
                                            <td className="taC">
                                                <span className="fm-c fs13 fc333333">
                                                    {Util.cvtDateStrForm(whdwlDt, "-", "YYYYMMDD")}
                                                </span>
                                            </td>
                                            <td className="taC">
                                                <span className="fm-c fs13 fc333333">
                                                    {Util.cvtDateStrForm(whdwlAprvDt, "-", "YYYYMMDD")}
                                                </span>
                                            </td>
                                            <td className="taC">
                                                <span className="fm-c fs13 fc333333">
                                                    {Util.cvtMonthStrForm(whdwlMm)}
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* 재가입 정보 */}
                <div className="ml10 mr10 mt20">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">재가입 정보</div>

                    <div className="p14 bd1 bdcDDDDDD bdrd10 bsBdb">
                        <div className="dpFlx flxNowrap jcSb">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    성명
                                </span>
                                <TextBox
                                    value={chgMbrasNm}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    onChangeFunc={(text: string) => setChgMbrasNm(text)}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    전화번호
                                </span>
                                <TextBox
                                    value={Util.setPhoneNum(chgTelno)}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="숫자만 입력"
                                    onChangeFunc={(text: string) => setChgTelno(text.replace(/[^0-9]/g, ""))}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    생년월일
                                </span>
                                <DatePickerBox
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="white"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={chgBrdtDate}
                                    onChange={(data: string) => setChgBrdtDate(data)}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    성별
                                </span>
                                <SelectBox
                                    value={chgGndrCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray("GNDR_CD")}
                                    placeholder="성별 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => setChgGndrCd(data)}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    본부
                                </span>
                                <SelectBox
                                    value={chgUpOgnzCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getUpOrgCodeArray("01").slice(1)}
                                    placeholder="본부 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => {
                                        setChgUpOgnzCd(data);
                                        setChgOgdpOrgCd("");
                                    }}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    근로형태
                                </span>
                                <SelectBox
                                    value={chgLbrShpSeCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray("LBR_SHP_SE_CD")}
                                    placeholder="근로형태 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => {
                                        setChgLbrShpSeCd(data);
                                        setChgOcptTypeCd("");

                                        if (data !== "01") {
                                            setFrstJncmpYmd("");
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    지부
                                </span>
                                <SelectBox
                                    value={chgOgdpOrgCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.isEmpty(chgUpOgnzCd) ? [] : Util.getDownOrgCodeArray(chgUpOgnzCd)}
                                    placeholder={Util.isEmpty(chgUpOgnzCd) ? "본부 먼저 선택" : "지부 선택"}
                                    paddingRight={8}
                                    disabled={Util.isEmpty(chgUpOgnzCd)}
                                    onChangeFunc={(data: string) => setChgOgdpOrgCd(data)}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">
                                    직종
                                </span>
                                <SelectBox
                                    value={chgOcptTypeCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.isEmpty(chgLbrShpSeCd) ? [] : Util.getCodeArray(chgLbrShpSeCd === "01" ? "PMEMP_OCPT_TYPE_CD" : "IREMP_OCPT_TYPE_CD")}
                                    placeholder={Util.isEmpty(chgLbrShpSeCd) ? "근로형태 먼저 선택" : "직종 선택"}
                                    paddingRight={8}
                                    disabled={Util.isEmpty(chgLbrShpSeCd)}
                                    onChangeFunc={(data: string) => setChgOcptTypeCd(data)}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">관내</span>
                                <TextBox
                                    value={chgWtjrNm}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="관내 입력"
                                    onChangeFunc={(text: string) => setChgWtjrNm(text)}
                                />
                            </div>

                            <div className="w280 dpFlx aiC">
                                <span className="w80 fm-b fs13 ls06 fc111111">상태</span>
                                <SelectBox
                                    value={chgMbrasJoinSttsCd}
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getCodeArray("MBRAS_JOIN_STTS_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                        {/* 입직년월일 - 정규직만 표시 */}
                        {chgLbrShpSeCd === "01" && (
                            <div className="w280 dpFlx aiC">
                                <div className="w80">
                                    <div className="fm-b fs13 ls06 fc111111">
                                        입직년월일
                                    </div>
                                    <div className="fm-c fs10 fc4A90A4 mt2">
                                        정규직 임용일자
                                    </div>
                                </div>

                                <DatePickerBox
                                    width={200}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="#FFF"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={frstJncmpYmd}
                                    onChange={(data: string) => setFrstJncmpYmd(data)}
                                />
                            </div>
                        )}

                        {/* 재가입 신청일자 */}
                        <div className="w280 dpFlx aiC">
                            <span className="w80 fm-b fs13 ls06 fc111111">
                                재가입<br />신청일자<span className="fcE60000">*</span>
                            </span>

                            <DatePickerBox
                                width={200}
                                height={36}
                                fontSize={14}
                                fontFamily="fm-c"
                                color="#333"
                                letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={5}
                                bgColor="white"
                                textAlign="left"
                                calendarThemeColor={AppContext.themeColor}
                                value={applyDt}
                                onChange={(data: string) => setApplyDt(data)}
                            />
                        </div>
                    </div>

                        <div className="dpFlx aiC mt10">
                            <span className="w80 fm-b fs13 ls06 fc111111">
                                주소
                            </span>
                            <TextBox
                                value={chgAddr}
                                width={500}
                                height={36}
                                fontSize={14}
                                fontFamily="fm-c"
                                color="#333"
                                letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={5}
                                style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                placeholder="주소를 입력하세요."
                                onChangeFunc={(text: string) => setChgAddr(text)}
                            />
                        </div>

                        <div className="dpFlx aiFs mt10">
                            <span className="w80 pt10 fm-b fs13 ls06 fc111111">메모</span>
                            <textarea
                                value={memo}
                                className="w500 h46 bsBdb p10 bd1 bdcDDDDDD bdrd5 fm-c fs14 fc333333 ls1 bgcWhite rszN"
                                maxLength={1000}
                                onChange={(event) => setMemo(event.target.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* 반려 사유 */}
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">반려 사유</span>
                        </div>
                        <textarea
                            value={atrzOpnnCn}
                            className="w610 h60 bsBdb p10 bd1 bdcDDDDDD bdrd4 fm-c fs14 fc333333 ls1 rszN"
                            style={{ backgroundColor: "#f6f6f6" }}
                            maxLength={2000}
                            disabled={true}
                        />
                    </div>
                )}

                {/* 첨부파일 */}
                <div className="mt20 p14 bd1 bdcDDDDDD bdrd10 w610 bgcFAFAFA bsBdb ml10">
                    <div className="fm-c fs16 fc111111 mb10">첨부파일</div>

                    <div className="mb12">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">가입신청서</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={joinAtchFileId}
                                setMbrasAtchFileId={setJoinAtchFileId}
                                mbrFile={joinFile}
                                setMbrFile={setJoinFile}
                                mbrFileNm={joinFileNm}
                                setMbrFileNm={setJoinFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>

                    <div className="mb12">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">원천징수 동의서</span>
                            <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={wthdAtchFileId}
                                setMbrasAtchFileId={setWthdAtchFileId}
                                mbrFile={wthdFile}
                                setMbrFile={setWthdFile}
                                mbrFileNm={wthdFileNm}
                                setMbrFileNm={setWthdFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">기타 첨부파일</span>
                            <span className="fm-c fs11 fc007bff ml4">(필수 아님)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                setMbrasAtchFileId={setEtcAtchFileId}
                                mbrFile={etcFile}
                                setMbrFile={setEtcFile}
                                mbrFileNm={etcFileNm}
                                setMbrFileNm={setEtcFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                                width={580}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt10 taC">
                    <span className="fm-c fs12 fc4A90A4">
                        ※ 임시저장은 입력 중인 내용으로 저장되며, 작성완료는 필수 항목 입력 후 가능합니다.
                    </span>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb10">
                    {Util.isEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styCancelBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="이전"
                            onClickFunc={() => setModalStep("CHANGE_TYPE")}
                        />
                    )}

                    <Button
                        width={90}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => setModalOpen(false)}
                    />

                    {Util.isNotEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styDeleteBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="삭제"
                            onClickFunc={handleDelete}
                        />
                    )}

                    {atrzSttsCd === "01" && (
                        <Button
                            width={110}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styTempBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="임시저장"
                            onClickFunc={() => handleSave("01")}
                        />
                    )}

                    <Button
                        width={110}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCompleteBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="작성완료"
                        onClickFunc={() => handleSave("02")}
                    />
                </div>
            </div>
        </div>
    );
};

export default MbrasRejoinApply;